// dependencies
import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import { StyleSheet, css } from "aphrodite";

// constants
import theming from "@cloudspire/legacy-resources/src/constants/theming";

const { useTheme } = theming;

const styles = StyleSheet.create({
  textInput: {
    borderStyle: "dashed",
    borderColor: "black",
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 1,
    borderLeftWidth: 0,
    fontSize: "1rem",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    maxWidth: "3.75rem",
    textAlign: "center",
  },
});

type PropsType = {
  value: string;
} & React.HTMLProps<HTMLInputElement>;

const NumberOfAdults: React.FunctionComponent<PropsType> = (props) => {
  const { value, ...otherProps } = props;

  const intl = useIntl();

  const theme = useTheme();

  const dynamicStyles = useMemo(
    () =>
      StyleSheet.create({
        textInput: {
          borderColor: theme.PRIMARY_COLOR_TEXT,
          fontFamily: theme.FONT_FAMILY,
        },
      }),
    [theme]
  );

  return (
    <>
      <input
        {...otherProps}
        type="number"
        value={value}
        className={css(styles.textInput, dynamicStyles.textInput)}
      />
      {` ${intl.formatMessage(
        {
          defaultMessage:
            "{numberOfAdults, plural, =0 {adulte} one {adulte} other {adultes}}",
        },
        { numberOfAdults: value }
      )}`}
    </>
  );
};

export default NumberOfAdults;
